import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueBus from 'vue-bus'
import App from './App.vue'
import router from '@/common/router'
import store from '@/common/store'
import utils from '@/common/utils.js'
import dictSelector from "@/components/_com/selectorDict.vue"
import staffSelector from "@/components/_com/selectorStaff.vue"
import medicareDialog from "@/components/_medcom/medicareDialog"
import medHospital from "@/components/_com/medHospital.vue"
import medOpspDise from "@/components/_com/medOpspDise.vue"

const idCardReader = () => import(/* webpackChunkName: 'idCardReader' */ '@/components/_com/idCardReader')
const datetimerange = () => import(/* webpackChunkName: 'datetimerange' */ './components/_com/datetimerange');
const dateRangePicker = () => import(/* webpackChunkName: 'dateRangePicker' */ './components/_com/dateRangePicker');

// import socket from '@/common/socket.js'
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueBus)
Vue.use(utils)
// Vue.use(socket)
Vue.component('id-reader', idCardReader) // 20220629，全局安装身份证识别器组件
Vue.component('dict-select', dictSelector)
Vue.component('dict-selector', dictSelector)
Vue.component('staff-selector', staffSelector)
Vue.component('hospital-select', medHospital)
Vue.component('opsp-dise-select', medOpspDise)
Vue.component('datetimerange', datetimerange); // 日期时间组件
Vue.component('dateRangePicker', dateRangePicker); // 日期组件
Vue.component('med-reader', medicareDialog)
// console.log(cfg.sys.name)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
